import styled from "styled-components";
import { TicketType, PrizeList } from "../constants/cash-status";
import TicketIcon from "@/assets/icons/topup/ticket";

export function TicketCard({
  isActive,
  type,
  number,
  prizeCardText,
}: {
  isActive: boolean;
  type: TicketType;
  number: string;
  prizeCardText?: string;
}) {
  const { fillColor, prizeColor, prizeBgColor } = PrizeList[type] || {
    fillColor: "",
    prizeCode: "",
    prizeBgColor: "",
  };
  return (
    <LotteryCard
      isActive={isActive}
      isWinPrize={!isActive}
      prizeBgColor={prizeBgColor}
      prizeColor={fillColor}
      textColor={prizeColor}
      isDisableStatus={!isActive && !prizeCardText}
    >
      <div className={"number"}>
        {
          <TicketIcon
            fill={isActive || prizeCardText ? "#ffffff" : "#C0C6CA"}
          />
        }
        {number}
      </div>
      {!isActive && type !== TicketType.NoCash && prizeCardText && (
        <div className={"prize"}>{prizeCardText}</div>
      )}
    </LotteryCard>
  );
}

const LotteryCard = styled.div<{
  isActive: boolean;
  isWinPrize: boolean;
  prizeBgColor: string;
  prizeColor: string;
  textColor: string;
  isDisableStatus: boolean;
}>`
  background: ${(props) =>
    props.isActive
      ? "linear-gradient(98.16deg, #5DE293 2.09%, #73CDE9 98.11%)"
      : props.isDisableStatus
      ? "#474F59"
      : props.prizeColor};
  border-radius: 4px;
  width: 130px;
  height: ${(props) => (props.isWinPrize ? "60px" : "46px")};
  margin-right: 16px;
  margin-bottom: 10px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  color: ${(props) => props.isDisableStatus && "#C0C6CA"};
  .number {
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 16px;
    color: #fff;
  }
  .prize {
    background: ${(props) => (props.isActive ? "#FE877E" : props.prizeBgColor)};
    height: 20px;
    font-size: ${(props) => !props.isWinPrize && "12px"};
    color: ${(props) => (props.isActive ? "#AA2111" : props.textColor)};
    width: 100%;
    text-align: center;
    line-height: 1;
    padding-top: 3px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
